module.exports = __webpack_public_path__ + "static/media/b1_p3_scout.72c2b004.mp3";